// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "82f0e111ed6bd9f1","191": "9e100af8b8e0d064","396": "aa497bab468a054f","460": "c3ad6435c1447482","498": "2c4c0fd67394e9e1","917": "924db7d40fe2ee9e","985": "d9e89f3e6c868c14",}[chunkId] + ".chunk.js"
}